// extracted by mini-css-extract-plugin
export default {"container":"UserAppRoleSelect_container__4YboH","combobox":"UserAppRoleSelect_combobox__5GTwH","tooltipWrapper":"UserAppRoleSelect_tooltipWrapper__xhc71"};